import { AccountStatuses, AccountType, AuditOperation, BusinessCategoryEnum, CategoryNamespace, CostProvider, CostSource, CustomerAccountAction, CustomerInvoicingStatuses, CustomerPaymentStrategies, CustomerStatuses, DataSourceProvider, DateType, EnvironmentStatus, ErroredSkuStatus, InvoiceApprovalState, InvoiceStatus, InvoiceType, JobType, LogicalCategoryEnum, PatternStatuses, PrepaymentBucket, PrepaymentInvoiceType, PrepaymentStatus, PricingRuleType, PricingType, ProcessingStatus, ReportingStatus, SkuMappingStatus, SkuStatus, SortOrder, ThresholdCondition, UsageStrategyKey } from "@onereach/billing-shared";
export function PartialType(base) { return base; }
export function OmitType(base, _keys) { return base; }
export function PickType(base, _keys) { return base; }
export function IntersectionType(a, _b) { return a; }
export var FlowDeploymentAction;
(function (FlowDeploymentAction) {
    FlowDeploymentAction["ACTIVATE"] = "activate";
    FlowDeploymentAction["DEACTIVATE"] = "deactivate";
})(FlowDeploymentAction || (FlowDeploymentAction = {}));
export var ProcessType;
(function (ProcessType) {
    ProcessType["DATA_COLLECT"] = "data_collect";
})(ProcessType || (ProcessType = {}));
export var AwsResourceSortBy;
(function (AwsResourceSortBy) {
    AwsResourceSortBy["RESOURCE_ID"] = "resourceId";
    AwsResourceSortBy["ACCOUNT_ID"] = "accountId";
    AwsResourceSortBy["SERVICE"] = "service";
    AwsResourceSortBy["PRODUCT_ID"] = "productId";
    AwsResourceSortBy["PROJECT_ID"] = "projectId";
    AwsResourceSortBy["DATE_FROM"] = "dateFrom";
    AwsResourceSortBy["DATE_TO"] = "dateTo";
    AwsResourceSortBy["COST"] = "cost";
})(AwsResourceSortBy || (AwsResourceSortBy = {}));
export var UsageCostCollectionProvider;
(function (UsageCostCollectionProvider) {
    UsageCostCollectionProvider["VANTAGE"] = "vantage";
    UsageCostCollectionProvider["TELNYX"] = "telnyx";
    UsageCostCollectionProvider["TWILIO"] = "twilio";
    UsageCostCollectionProvider["VONAGE"] = "vonage";
    UsageCostCollectionProvider["BANDWIDTH"] = "bandwidth";
    UsageCostCollectionProvider["OPENAI"] = "openai";
    UsageCostCollectionProvider["DEEPGRAM"] = "deepgram";
})(UsageCostCollectionProvider || (UsageCostCollectionProvider = {}));
export var MappingStatus;
(function (MappingStatus) {
    MappingStatus["MAPPED"] = "mapped";
    MappingStatus["UNMAPPED"] = "unmapped";
})(MappingStatus || (MappingStatus = {}));
export { AccountStatuses, AccountType, AuditOperation, BusinessCategoryEnum, CategoryNamespace, CostProvider, CostSource, CustomerAccountAction, CustomerInvoicingStatuses, CustomerPaymentStrategies, CustomerStatuses, DataSourceProvider, DateType, EnvironmentStatus, ErroredSkuStatus, InvoiceApprovalState, InvoiceStatus, InvoiceType, JobType, LogicalCategoryEnum, PatternStatuses, PrepaymentBucket, PrepaymentInvoiceType, PrepaymentStatus, PricingRuleType, PricingType, ProcessingStatus, ReportingStatus, SkuMappingStatus, SkuStatus, SortOrder, ThresholdCondition, UsageStrategyKey };
export { PrepaymentStatus as Status } from "@onereach/billing-shared";
